import React from "react";

import { useTranslation } from "react-i18next";

import { QuestionCircleFilled } from "@ant-design/icons";

import styles from "./styles.module.scss";

export const TableNotification: React.FC<{ text?: string }> = (props) => {
  const { text } = props;
  const { t } = useTranslation("table_notification");

  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <QuestionCircleFilled />
      </div>
      <span className={styles.text}>{text || t("defaultText")}</span>
    </div>
  );
};
